'use client'

import { useCallback } from 'react'

import { useExperimentsContext } from '../experiments/components/ExperimentsContext'
import { useGlobalConfigContext } from '../global-config'

import { type UdpTrackingMetadata } from './model/udpTrackingTypes'
import { udpTrackingBuildMetadata } from './udpTrackingBuildMetadata'

export const useUdpTrackingBuildMetadata = (): (() => UdpTrackingMetadata) => {
  const { optimizelyVisitorId } = useExperimentsContext()
  const globalConfig = useGlobalConfigContext()

  return useCallback(
    () => udpTrackingBuildMetadata({ globalConfig, optimizelyVisitorId }),
    [globalConfig, optimizelyVisitorId],
  )
}
